export default {
  allReviews: {
    id: 'landing_best_reviews_more',
    defaultMessage: 'See all reviews',
  },
}
